/**
 * McSticky: Handles sticky header behavior using state classes on document.body.
 * States:
 * - default (no class): Static position
 * - mc-sticky-scrolled: User has scrolled past the topbar
 * - mc-sticky-up: User is scrolling UP (sticky visible)
 * - mc-sticky-down: User is scrolling DOWN (sticky hidden)
 */
const McSticky = (function () {
  const CLASSES = {
    scrolled: "mc-sticky-scrolled",
    up: "mc-sticky-up",
    down: "mc-sticky-down",
  };

  let lastScrollTop = 0;
  let rafId = null;

  function init() {
    window.addEventListener("scroll", onScroll, { passive: true });
    // Initial check
    onScroll();
  }

  function onScroll() {
    if (rafId) return;

    rafId = requestAnimationFrame(() => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      handleScrollState(scrollTop);
      rafId = null;
    });
  }

  function handleScrollState(scrollTop) {
    if (scrollTop < 0) return; // Ignore bounce

    const body = document.body;
    const threshold = 100; // Pixel threshold to enable sticky logic

    // Check direction
    const isScrollingDown = scrollTop > lastScrollTop;
    lastScrollTop = scrollTop;

    if (scrollTop <= threshold) {
      // At top - Reset to static
      // We keep 'mc-sticky-scrolled' off when at the very top to reset animations
      body.classList.remove(CLASSES.scrolled, CLASSES.up, CLASSES.down);
      return;
    }

    // Past threshold
    if (!body.classList.contains(CLASSES.scrolled)) {
      body.classList.add(CLASSES.scrolled);
    }

    if (isScrollingDown) {
      // Scrolling Down
      if (!body.classList.contains(CLASSES.down)) {
        body.classList.remove(CLASSES.up);
        body.classList.add(CLASSES.down);
      }
    } else {
      // Scrolling Up
      if (!body.classList.contains(CLASSES.up)) {
        body.classList.remove(CLASSES.down);
        body.classList.add(CLASSES.up);
      }
    }
  }

  return { init };
})();

document.addEventListener("DOMContentLoaded", McSticky.init);
